export const filterOptions = [
  { name: "Card ID", value: "cardNumber" },
  { name: "Type", value: "type" },
  { name: "State", value: "state" },
  { name: "Depot", value: "depot" },
];

export const RESOLUTIONS = {
  REFURBRISHED: "Stove Repaired",
  REPAIR: "Sent to Supplier",
};

export const faultOrigins = ["Company", "Customer", "Unknown"];

export const RESOLUTION_OPTIONS = [
  { name: "Refurbished", value: RESOLUTIONS.REFURBRISHED },
  { name: "For Repair", value: RESOLUTIONS.REPAIR },
];

export const RESOLUTION_TYPES = {
  [RESOLUTIONS.REFURBRISHED]: {
    title: "STOVE IS REFURBISHED",
    description: "Confirming this option will change the status of the stove to “REFURBISHED”.",
  },
  [RESOLUTIONS.REPAIR]: {
    title: "STOVE IS FOR REPAIR",
    description: "Confirming this option will change the status of the stove to “FOR REPAIR”.",
  },
};

export const STATUS_COLOR_MAP = {
  "RFID Card": {
    color: "#0085FF",
    backgroundColor: "#0085FF33",
  },
  "Virtual Card": {
    color: "#743DD3",
    backgroundColor: "#743DD326",
  },
};
